import { LocalVideo, RemoteVideo, useAttendeeStatus } from 'amazon-chime-sdk-component-library-react';
import classNames from 'classnames';
import React from 'react';
import { useExternalUserId, useSession, useTileId } from '../../session-provider';
import { useVideoConfig } from '../../video-config-provider';
import s from './tile.scss';
import { Content } from './content';
export const Tile = ({ className, attendeeId, focused }) => {
    const { renderAvatar, video, dashboard } = useVideoConfig();
    const { currentAttendeeId } = useSession();
    const { videoEnabled: attendeeVideoEnabled } = useAttendeeStatus(attendeeId);
    const tileId = useTileId(attendeeId);
    const externalUserId = useExternalUserId(attendeeId);
    const localTile = attendeeId === currentAttendeeId;
    const videoEnabled = localTile ? video : attendeeVideoEnabled;
    return videoEnabled ? (React.createElement(Content, { className: className, attendeeId: attendeeId, focused: focused }, localTile ? React.createElement(LocalVideo, null) : React.createElement(RemoteVideo, { tileId: tileId }))) : (React.createElement(Content, { className: classNames(className, s.tile, { [s.dashboardTile]: dashboard }), attendeeId: attendeeId, focused: focused }, Boolean(renderAvatar) && renderAvatar(externalUserId)));
};
//# sourceMappingURL=tile.js.map